import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

const { communicationName, channel } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	// outputs only
	channel,
	state: 'state',
	communicationName,
};
